import React from 'react';
import { Buildings, PaintBrush, Diamond, ArrowsLeftRight, WarningCircle, CheckCircle } from '@phosphor-icons/react';

export default function StatsGrid({ stats }) {
  const cards = [
    { label: 'Total Users', value: stats?.users?.total || 0, icon: <Buildings size={18} weight="regular" /> },
    { label: 'Galleries', value: stats?.users?.galleries || 0, icon: <Buildings size={18} weight="regular" /> },
    { label: 'Artists', value: stats?.users?.artists || 0, icon: <PaintBrush size={18} weight="regular" /> },
    { label: 'Collectors', value: stats?.users?.collectors || 0, icon: <Diamond size={18} weight="regular" /> },
    { label: 'Transactions', value: stats?.transactions?.total || 0, icon: <ArrowsLeftRight size={18} weight="regular" />, accent: true },
    { label: 'Released', value: stats?.transactions?.released || 0, icon: <CheckCircle size={18} weight="regular" />, color: 'text-tf-success' },
    { label: 'Disputed', value: stats?.transactions?.disputed || 0, icon: <WarningCircle size={18} weight="regular" />, color: 'text-tf-danger' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 border border-tf-primary" data-testid="stats-grid">
      {cards.map((card, i) => (
        <div
          key={card.label}
          className={`p-3 sm:p-4 lg:p-5 border-b sm:border-b lg:border-b-0 border-tf-border-light ${
            i % 2 === 0 ? 'border-r border-tf-border-light' : ''
          } sm:border-r lg:${i < cards.length - 1 ? 'border-r' : 'border-r-0'} ${
            card.accent ? 'bg-tf-primary text-white' : 'bg-tf-surface'
          } hover:-translate-y-0.5 transition-all duration-300`}
          data-testid={`stat-${card.label.toLowerCase().replace(/\s/g, '-')}`}
        >
          <div className={`mb-2 sm:mb-3 ${card.accent ? 'text-white/60' : card.color || 'text-tf-text-2'}`}>{card.icon}</div>
          <div className={`font-heading font-bold text-xl sm:text-2xl tracking-tight ${card.accent ? 'text-white' : 'text-tf-text'}`}>{card.value}</div>
          <div className={`font-mono text-[8px] sm:text-[9px] tracking-[0.15em] sm:tracking-[0.2em] uppercase mt-1 ${card.accent ? 'text-white/60' : 'text-tf-text-2'}`}>{card.label}</div>
        </div>
      ))}
    </div>
  );
}
